 <div class="footer no-print">
    <nav class="navbar navbar-default footer-bottom">

        <div class="container col-md-12">
            <div class="col-md-4 d-flex align-items-md-center"></div>
            <div class="col-md-12 d-flex flex-column align-items-md-end">
                <p class="font-weight-bold mb-0">
                    <a class="font-weight-bold font-color" [routerLink]="['/terms-and-conditions-service']"
                        title="Terms and Conditions of Service">{{'TERMS_AND_CONDITIONS_OF_SERVICE' |
                        translate}}</a>&nbsp;|&nbsp;<a class="font-weight-bold font-color"
                        [routerLink]="['/terms-and-conditions']"
                        title="Terms and Conditions of Site Use">{{'TERMS_AND_CONDITIONS_OF_SITE_USE' |
                        translate}}</a>&nbsp;|&nbsp;<a class="font-weight-bold font-color" [routerLink]="['/privacy-statement']"
                        title="Privacy Statement">{{'PRIVACY' | translate}}</a>
                        &nbsp;|&nbsp;<a class="font-weight-bold font-color"
                            href="javascript:void(0)"
                            (click)="openCookiePreferences()">
                            {{ 'COOKIE_PREFERENCES' | translate }}
                        </a>
                </p>
                <p style="color:#111">{{'COPYRIGHTS_TEXT' | translate: {'year': year} }}
                </p>
            </div>

        </div>
    </nav>
</div>